<template>
  <b-modal
    :id="MODAL_ID"
    size="xl"
    hide-footer
    centered
    modal-class="translation-settings-modal"
  >
    <template #modal-header="{ close }">
      <div class="translation-settings-modal__header w-100">
        <button
          type="button"
          class="translation-settings-modal__back"
          aria-label="Back"
          @click="close"
        >
          <i class="bi bi-arrow-left-short" />
        </button>
        <div class="translation-settings-modal__title">
          Translation Settings
        </div>
        <button
          type="button"
          class="translation-settings-modal__close"
          aria-label="Close"
          @click="close"
        >
          ×
        </button>
      </div>
    </template>

    <TranslationSettingsView mode="modal" />
  </b-modal>
</template>

<script>
import TranslationSettingsView from "./TranslationSettingsView.vue";

const MODAL_ID = "translation-settings-modal";

export default {
  name: "TranslationSettingsModal",
  components: { TranslationSettingsView },
  data() {
    return { MODAL_ID };
  },
};
</script>

<style scoped lang="scss">
.translation-settings-modal__header {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
}

.translation-settings-modal__back,
.translation-settings-modal__close {
  border: 0;
  background: transparent;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111827;
}

.translation-settings-modal__back:hover,
.translation-settings-modal__close:hover {
  background: #f3f4f6;
}

.translation-settings-modal__back-icon {
  font-size: 16px !important;
  line-height: 1;
  display: block;
}

.translation-settings-modal__title {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
  justify-self: start;
}

/* Constrain modal to viewport; body scrolls (table stays inside). */
::v-deep .translation-settings-modal .modal-content {
  border-radius: 12px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

::v-deep .translation-settings-modal .modal-header {
  border-bottom: 0;
  padding: 18px 20px 8px;
}

::v-deep .translation-settings-modal .modal-body {
  padding: 6px 20px 20px;
  overflow: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.translation-settings-modal__back i {
  font-size: 24px !important;
}

.translation-settings-modal__close {
  font-size: 24px !important;
}
</style>

